import { Component, effect, OnDestroy, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SHARED_IMPORTS } from './shared/shared-imports';
import { idleService } from './shared/services/idle-service';
import { TranslateService } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';
import { GraphService } from './shared/services/graph-service';
import { ApiCallingService } from './shared/services/api-calling-service';
import { ApiRoutes } from './shared/api-routes';
import { sharedBroadcast } from './pages/header/header';
import { environment } from '../environments/environment.test';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SHARED_IMPORTS, ProgressSpinnerModule],
  providers: [MessageService],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  protected readonly projectName = signal('Download_Area');
  ssoProfileArr: any;
  isLoading = signal(false);
  loadingMessage = signal('Signing in with SSO...');
  constructor(
    private idleService: idleService,
    private messageService: MessageService,
    private translate: TranslateService,
    private msalService: MsalService,
    private graphService: GraphService,
    private apiCallingService: ApiCallingService,
    private router: Router,
  ) {
    effect(() => {
      const message = this.idleService.toastMessageSignal();
      if (message) {
        // Show toast, or trigger UI logic
        this.messageService.add(message);
      }
    });

    this.translate.onLangChange.subscribe((event) => {
      const htmlEl = document.documentElement;
      htmlEl.classList.remove('lang-1', 'lang-2');
      htmlEl.classList.add(`lang-${event.lang}`);
    });

    // Optionally, set initial language class
    const initialLang = this.translate.currentLang || '1';
    document.documentElement.classList.add(`lang-${initialLang}`);
  }

  // async ngOnInit() {
  //   this.isLoading.set(true);

  //   try {
  //     // Initialize MSAL
  //     await this.msalService.instance.initialize();

  //     // Handle redirect response
  //     const result = await this.msalService.instance.handleRedirectPromise();

  //     // Get account from redirect OR existing browser session
  //     let account = result?.account;

  //     if (!account) {
  //       const accounts = this.msalService.instance.getAllAccounts();

  //       if (accounts.length > 0) {
  //         account = accounts[0];
  //       }
  //     }

  //     // No Microsoft account available
  //     // Don't auto-login
  //     if (!account) {
  //       this.isLoading.set(false);
  //       return;
  //     }

  //     // Get Microsoft email
  //     const email = account.username || account.idTokenClaims?.['preferred_username'] || '';

  //     console.log('Browser Microsoft account:', email);

  //     // =====================================================
  //     // ONLY @moba.de USERS CAN AUTO LOGIN
  //     // =====================================================

  //     if (!email.toLowerCase().endsWith('@moba.de')) {
  //       console.log('Non-MOBA account detected. Automatic login skipped.');

  //       this.isLoading.set(false);

  //       // IMPORTANT:
  //       // Do NOT call SSO_LOGIN
  //       // Do NOT call Graph API
  //       // Do NOT set isUserLogged
  //       // Do NOT set Auth_token
  //       // Do NOT navigate

  //       return;
  //     }

  //     // =====================================================
  //     // MOBA USER
  //     // =====================================================

  //     console.log('MOBA user detected. Starting automatic login.');

  //     this.msalService.instance.setActiveAccount(account);

  //     this.idleService.startInactivityTimer();

  //     // Get Microsoft Graph profile
  //     this.graphService.getProfile().subscribe({
  //       next: (res: any) => {
  //         this.ssoProfileArr = res;

  //         const graphEmail = res.mail || res.userPrincipalName || email;

  //         // Double-check the domain
  //         if (!graphEmail.toLowerCase().endsWith('@moba.de')) {
  //           console.log('Graph account is not @moba.de. Auto login cancelled.');

  //           this.isLoading.set(false);
  //           return;
  //         }

  //         const payload = {
  //           displayName: res.displayName,
  //           givenName: res.givenName,
  //           jobTitle: res.jobTitle,
  //           mail: res.mail,
  //           mobilePhone: res.mobilePhone ?? '',
  //           officeLocation: res.officeLocation,
  //           preferredLanguage: res.preferredLanguage,
  //           surname: res.surname,
  //           userPrincipalName: res.userPrincipalName,
  //           id: res.id,
  //           loginWith: 0,
  //         };

  //         // Backend SSO login
  //         this.apiCallingService.callAPI(payload, 'POST', ApiRoutes.URLS.SSO_LOGIN).subscribe({
  //           next: (response: any) => {
  //             const parsed = JSON.parse(response);

  //             if (parsed.responseCode === 200) {
  //               const data = parsed.data[0];

  //               const localData = {
  //                 user_info: data,
  //               };

  //               localStorage.setItem('isUserLogged', 'true');

  //               localStorage.setItem('Auth_token', data.tokenKey);

  //               localStorage.setItem('languageId', atob(data.languageId));

  //               localStorage.setItem('Auth-user', JSON.stringify(localData));

  //               localStorage.setItem('userLoginDateTime', Date.now().toString());

  //               this.idleService.startAutoLogoutFromLoginTime();

  //               this.getAccessPage(ApiRoutes.URLS.GET_ACCESS_PAGE_DATA, 'accesspage');

  //               setTimeout(() => {
  //                 this.isLoading.set(false);

  //                 this.router.navigate([this.getDefaultPage()]);

  //                 sharedBroadcast.postMessage('login');
  //               }, 1000);
  //             } else {
  //               this.isLoading.set(false);

  //               this.messageService.add({
  //                 severity: 'warn',
  //                 summary: 'Login',
  //                 detail: parsed.responseMessage || 'User is not authorized.',
  //               });
  //             }
  //           },

  //           error: (err: any) => {
  //             this.isLoading.set(false);

  //             console.error('SSO login error:', err);
  //           },
  //         });
  //       },

  //       error: (err: any) => {
  //         this.isLoading.set(false);

  //         console.error('Unable to get Microsoft profile:', err);
  //       },
  //     });
  //   } catch (error) {
  //     console.error('MSAL initialization error:', error);

  //     this.isLoading.set(false);
  //   }
  // }
  async ngOnInit() {
    // 1) Already logged into YOUR app → skip auto SSO
    if (localStorage.getItem('isUserLogged') === 'true' && localStorage.getItem('Auth_token')) {
      console.log('[SSO DEBUG] Already logged in → skip auto SSO');
      this.isLoading.set(false);
      // resume SSO token expiry timer after refresh
      this.idleService.resumeSsoTokenExpiryLogoutIfNeeded();
      this.idleService.startInactivityTimer();
      this.idleService.startAutoLogoutFromLoginTime();
      return;
    }
    const currentHost = window.location.hostname.toLowerCase();
    const isAllowedHost = currentHost === environment.AllowedHosts.toLowerCase();
    console.log('currentHost',currentHost,'environment.AllowedHosts.toLowerCase()',environment.AllowedHosts.toLowerCase())

    const currentPath = window.location.pathname.toLowerCase();
    const isBaseDomain = currentPath === '/' || currentPath === '' || currentPath === '/landingpage' || currentPath === '/login';
    const hasMsalCode = window.location.hash.includes('code=') || window.location.search.includes('code=');

    console.log ('isAllowedhost',isAllowedHost,'isBaseDomain',isBaseDomain,'hasMsalCode',hasMsalCode);
    

    if (!isAllowedHost || (!isBaseDomain && !hasMsalCode)) {
      console.log(`[SSO DEBUG] Host (${currentHost}) or Path (${currentPath}) is not allowed → skip auto SSO completely.`);
      this.isLoading.set(false);
      return; // STOP RIGHT HERE IF NOT ON PROD DOMAIN
    }

    // Only show loading spinner on main top window, not inside hidden iframe
    if (window.self === window.top) {
      this.isLoading.set(false);
    }

    try {
      // Initialize MSAL
      await this.msalService.instance.initialize();
      console.log('[SSO DEBUG] MSAL initialized');

      // -----------------------------------------------------------------------
      // 2) Handle redirect result
      // MUST run in BOTH top window AND hidden iframe so MSAL can parse #code=
      // -----------------------------------------------------------------------
      let result: any = null;
      try {
        result = await this.msalService.instance.handleRedirectPromise();
        console.log('[SSO DEBUG] handleRedirectPromise result:', result);
      } catch (redirectError: any) {
        console.warn(
          '[SSO DEBUG] handleRedirectPromise failed:',
          redirectError?.errorCode || redirectError?.message || redirectError
        );
        sessionStorage.removeItem('msal_prompt_none_tried');
        this.isLoading.set(false);
        return;
      }

      // -----------------------------------------------------------------------
      // 3) STOP IFRAME EXECUTION HERE!
      // Once handleRedirectPromise() finishes in the iframe, it has sent the token
      // to the parent window. Now the iframe can safely stop.
      // -----------------------------------------------------------------------
      if (window.self !== window.top) {
        console.log('[SSO DEBUG] Iframe handled redirect promise successfully.');
        return;
      }

      let account = result?.account ?? null;
      console.log('[SSO DEBUG] Account from redirect:', account?.username || null);

      // -------------------------------------------------
      // 4) Use MSAL cache first (best path after logout)
      // -------------------------------------------------
      if (!account) {
        const accounts = this.msalService.instance.getAllAccounts();
        console.log('[SSO DEBUG] getAllAccounts count:', accounts.length, accounts.map(a => a.username));
        if (accounts.length > 0) {
          account = accounts[0];
          console.log('Account from MSAL cache:', account?.username);
        }
      }

      // -------------------------------------------------
      // 5) ssoSilent ONLY if no cached account
      // -------------------------------------------------
      if (!account) {
        // First try silent iframe check
        try {
          console.log('Trying ssoSilent...');
          console.log('[SSO DEBUG] Calling ssoSilent with domainHint=moba.de');

          const silentResult = await this.msalService.instance.ssoSilent({
            scopes: ['User.Read'],
            domainHint: 'moba.de',
          });

          account = silentResult?.account ?? null;
          console.log('ssoSilent OK:', account?.username);
        } catch (silentError: any) {
          const code = silentError?.errorCode || silentError?.message || silentError;
          console.warn('[SSO DEBUG] ssoSilent failed (3rd party cookies blocked):', code);

          // Bypasses 3rd-party cookie blocking because top-level uses 1st-party cookies.
          const attempted = sessionStorage.getItem('msal_sso_attempted') === 'true';

          if (!attempted) {
            sessionStorage.setItem('msal_sso_attempted', 'true');
            console.log('[SSO DEBUG] Executing top-level loginRedirect(prompt:none) to restore SSO cache...');

            await this.msalService.instance.loginRedirect({
              scopes: ['User.Read'],
              prompt: 'none',
              domainHint: 'moba.de',
            });
            return; // Browser navigates to Microsoft and returns with token
          } else {
            console.log('[SSO DEBUG] Silent SSO not possible (no active MS session). Staying on login page.');
            this.isLoading.set(false);
            return;
          }
        }
      }

      if (!account) {
        console.log('No Microsoft account available. Auto-login skipped.');
        this.isLoading.set(false);
        return;
      }

      // Domain check for final account
      const email = account.username || account.idTokenClaims?.['preferred_username'] || '';
      if (!email.toLowerCase().endsWith('@moba.de')) {
        console.log(`[SSO] Non-MOBA account detected (${email}). Stopping SSO completely.`);
        this.isLoading.set(false);
        return;
      }


      console.log('[SSO DEBUG] Final account selected:', account?.username);

      // -------------------------------------------------
      // 6) Account found → @moba.de check + backend SSO
      // -------------------------------------------------
      await this.processMobaAutoLogin(account);
    } catch (error: any) {
      console.warn('MSAL auto-login skipped:', error?.errorCode || error);
      this.isLoading.set(false);
    }
  }

  /**
   * Check email domain + Graph + backend SSO_LOGIN
   */
  private async processMobaAutoLogin(account: any) {
    try {
      const email =
        account.username ||
        (account.idTokenClaims?.['preferred_username'] as string) ||
        '';

      console.log('Browser Microsoft account:', email);

      // ONLY @moba.de
      if (!email.toLowerCase().endsWith('@moba.de')) {
        console.log('Non-MOBA account. Auto login skipped.');
        // Ensure loader never shows for gmail/other emails
        this.isLoading.set(false);
        this.loadingMessage.set('Signing in with SSO...');
        return;
      }

      console.log('MOBA user detected. Starting automatic SSO login...');

      // Show loader ONLY for valid @moba.de SSO login
      if (window.self === window.top) {
        this.loadingMessage.set('Signing in with SSO...');
        this.isLoading.set(true);
      }

      this.msalService.instance.setActiveAccount(account);
      this.idleService.startInactivityTimer();

      // clean old flags
      sessionStorage.removeItem('msal_prompt_none_tried');

      this.graphService.getProfile().subscribe({
        next: (res: any) => {
          this.ssoProfileArr = res;

          const graphEmail = (res.mail || res.userPrincipalName || email || '').toLowerCase();

          if (!graphEmail.endsWith('@moba.de')) {
            console.log('Graph account is not @moba.de. Auto login cancelled.');
            this.isLoading.set(false);
            return;
          }

          const payload = {
            displayName: res.displayName,
            givenName: res.givenName,
            jobTitle: res.jobTitle,
            mail: res.mail || graphEmail,
            mobilePhone: res.mobilePhone ?? '',
            officeLocation: res.officeLocation,
            preferredLanguage: res.preferredLanguage,
            surname: res.surname,
            userPrincipalName: res.userPrincipalName || graphEmail,
            id: res.id,
            loginWith: 0,
          };

          console.log('Calling SSO_LOGIN with email:', payload.mail);

          this.apiCallingService.callAPI(payload, 'POST', ApiRoutes.URLS.SSO_LOGIN).subscribe({
            next: (response: any) => {
              const parsed = JSON.parse(response);

              if (parsed.responseCode === 200) {
                const data = parsed.data[0];
                const localData = { user_info: data };

                localStorage.setItem('isUserLogged', 'true');
                localStorage.setItem('Auth_token', data.tokenKey);
                localStorage.setItem('languageId', atob(data.languageId));
                localStorage.setItem('Auth-user', JSON.stringify(localData));
                localStorage.setItem('userLoginDateTime', Date.now().toString());
                localStorage.setItem('ssologin', 'true');

                // ===== SSO token expiry auto-logout =====
                // Get current MSAL access token expiry and start timer
                this.msalService.instance
                  .acquireTokenSilent({
                    scopes: ['User.Read'],
                    account: account,
                  })
                  .then((tokenResponse) => {
                    // expiresOn is Date; convert remaining seconds
                    const expiresInSeconds = tokenResponse.expiresOn
                      ? Math.max(Math.floor((tokenResponse.expiresOn.getTime() - Date.now()) / 1000), 0)
                      : 0;

                    console.log('[SSO] token expires_in (sec):', expiresInSeconds);
                    this.idleService.startSsoTokenExpiryLogout(expiresInSeconds);
                  })
                  .catch((err) => {
                    console.warn('[SSO] Could not read token expiry:', err);
                    // fallback: use 1 hour if unknown
                    this.idleService.startSsoTokenExpiryLogout(3600);
                  });
                // ===== end =====

                this.idleService.startAutoLogoutFromLoginTime();
                this.getAccessPage(ApiRoutes.URLS.GET_ACCESS_PAGE_DATA, 'accesspage');

                setTimeout(() => {
                  this.isLoading.set(false);
                  this.router.navigate([this.getDefaultPage()]);
                  sharedBroadcast.postMessage('login');
                }, 1000);
              } else {
                this.isLoading.set(false);
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Login',
                  detail: parsed.responseMessage || 'User is not authorized.',
                });
              }
            },
            error: (err: any) => {
              this.isLoading.set(false);
              console.error('SSO login error:', err);
            },
          });
        },
        error: (err: any) => {
          this.isLoading.set(false);
          console.error('Unable to get Microsoft profile:', err);

          // If Graph fails because token needs interaction, just show login page
          // Do not force prompt:none here
        },
      });
    } catch (e) {
      console.error('processMobaAutoLogin error:', e);
      this.isLoading.set(false);
    }
  }
  async ngOnInit1() {
    console.log(this.msalService.instance);
    const ssologin = localStorage.getItem('ssologin');
    if (ssologin === 'true') {
      this.idleService.startInactivityTimer();
      this.idleService.startAutoLogoutFromLoginTime();

      this.isLoading.set(true);

      try {
        await this.msalService.instance.initialize();

        const result = await this.msalService.instance.handleRedirectPromise();

        if (!result?.account) {
          this.isLoading.set(false);
          return;
        }

        this.msalService.instance.setActiveAccount(result.account);

        this.graphService.getProfile().subscribe({
          next: (res: any) => {
            this.ssoProfileArr = res;

            const payload = {
              displayName: res.displayName,
              givenName: res.givenName,
              jobTitle: res.jobTitle,
              mail: res.mail,
              mobilePhone: res.mobilePhone ?? '',
              officeLocation: res.officeLocation,
              preferredLanguage: res.preferredLanguage,
              surname: res.surname,
              userPrincipalName: res.userPrincipalName,
              id: res.id,
              loginWith: 0,
            };

            this.apiCallingService.callAPI(payload, 'POST', ApiRoutes.URLS.SSO_LOGIN).subscribe({
              next: (response: any) => {
                const parsed = JSON.parse(response);

                if (parsed.responseCode === 200) {
                  const data = parsed.data[0];
                  let localData = {
                    user_info: parsed.data[0],
                  };
                  localStorage.setItem('isUserLogged', 'true');
                  localStorage.setItem('Auth_token', data.tokenKey);
                  localStorage.setItem('languageId', atob(data.languageId));
                  localStorage.setItem('Auth-user', JSON.stringify(localData));
                  localStorage.setItem('userLoginDateTime', Date.now().toString());
                  this.idleService.startAutoLogoutFromLoginTime();
                  this.getAccessPage(ApiRoutes.URLS.GET_ACCESS_PAGE_DATA, 'accesspage');

                  setTimeout(() => {
                    this.isLoading.set(false);
                    this.router.navigate([this.getDefaultPage()]);
                    sharedBroadcast.postMessage('login');
                  }, 1000);
                } else if (parsed.responseCode === 203) {
                  this.isLoading.set(false);
                }
              },
              error: (err: any) => {
                this.isLoading.set(false);

                const errorResponse = JSON.parse(err.error);

                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail:
                    errorResponse.responseMessage.charAt(0).toUpperCase() +
                    errorResponse.responseMessage.slice(1).toLowerCase(),
                });

                this.msalService.logoutRedirect({
                  postLogoutRedirectUri: window.location.origin,
                });
              },
            });
          },
          error: (err: any) => {
            this.isLoading.set(false);
          },
        });
      } catch (error) {
        this.isLoading.set(false);
      }
    }
  }

  ngOnDestroy(): void {
    this.idleService.stopInactivityTimer();
  }

  getAccessPage(url: string, type: 'accesspage'): void {
    let finalUrl = `${url}?publicKey=${environment.PublicKey}`;
    this.apiCallingService.callAuthPostAPI({}, 'GET', finalUrl).subscribe({
      next: (response: any) => {
        response = JSON.parse(response);
        if (response.responseCode === 200) {
          if (type === 'accesspage') {
            localStorage.setItem('accessPage', JSON.stringify(response.data));
          }
        }
      },
      error: (errorResponse: any) => {
        errorResponse = JSON.parse(errorResponse.error);
        const message = errorResponse.responseMessage
          ? errorResponse.responseMessage.toLowerCase()
          : '';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            errorResponse.responseMessage.charAt(0).toUpperCase() +
            errorResponse.responseMessage.slice(1).toLowerCase(),
        });
      },
    });
  }

  getDefaultPage() {
    const accessPage = JSON.parse(localStorage.getItem('accessPage') || '[]');

    const hasDashboardAccess = accessPage.some(
      (item: any) =>
        item.controller === 'dashboard' ||
        (Array.isArray(item.SubMenu) &&
          item.SubMenu.some((sub: any) => sub.controller === 'dashboard')),
    );

    if (hasDashboardAccess) {
      localStorage.setItem('defaultPage', 'dashboard');
      return 'dashboard';
    } else {
      localStorage.setItem('defaultPage', 'profile');
      return 'profile';
    }
  }
}
